import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {NumAnnoMeseFilterComponent} from '../../../general-components/filter/num-anno-mese-filter/num-anno-mese-filter.component';
import {Offset} from '../../../../models/Offset';
import {Subscription} from 'rxjs';
import {HttpHeaders} from '@angular/common/http';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {DomSanitizer} from '@angular/platform-browser';
import * as FileSaver from 'file-saver';
import * as toastr from 'toastr';
import {ChargesScartoService} from '../service-charges-scarto/charges-scarto.service';
import {ScartiConsuntivoChargesModel, ScartiConsuntivoChargesReportModel} from '../../../../models/ScartiConsuntivoChargesModel';
import { MatDialog } from '@angular/material/dialog';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {ProviderModel} from '../../../../models/ProviderModel';

@Component({
  selector: 'app-filter-waste-charges',
  templateUrl: './filter-waste-charges.component.html',
  styleUrls: ['./filter-waste-charges.component.scss']
})
export class FilterWasteChargesComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  regionCod: string;
  localCustomerCod: string;
  resourceUnitCod: string;
  designedServiceCod: string;
  contractTypeCod: string;
  providerCod: string;
  offset: Offset;
  fileName: string;
  filter: ScartiConsuntivoChargesModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;

  intermittentBool: boolean;

  httpOptions = {
    headers: new HttpHeaders({
      Accept: 'application/csv',
      'Authorization': 'Bearer ' + sessionStorage.getItem('authToken')
    }),
    responseType: 'application/csv'
  };

  @ViewChild(NumAnnoMeseFilterComponent, { static: true }) numAnnoFilterComponent;

  @Input() reportSection?: boolean;
  @Input() numAnnoMeseData?: number;
  @Output() dataFiltered = new EventEmitter<any>();

  constructor(private loaderService: LoaderService,
              private chargesScartoService: ChargesScartoService,
              private sanitizer: DomSanitizer,
              private dialog: MatDialog) {
    super();
    const providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;

    this.numAnnoMeseData = null;
    this.regionCod = null;
    this.localCustomerCod = null;
    this.resourceUnitCod = null;
    this.designedServiceCod = null;
    this.contractTypeCod = null;
    this.providerCod = providerSelect.cod;
  }

  ngOnInit() {
    this.filter = new ScartiConsuntivoChargesModel();
    const lastMonth = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filter.numAnnoMese = Number(lastMonth.lastUploadedVolume);
    this.offset = new Offset(+this.PAGINATOR.PAGE_SIZE_ARRAY[0], 0);
  }


  filterTable(): void {
    this.loaderService.display(true);

    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    this.dataFiltered.emit(this.filter);
  }

  resetTable() {
    const providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }
    if(!this.providerCod.includes('KYN')){
      this.regionCod = null;
      this.contractTypeCod = null;
    }

    this.numAnnoFilterComponent.reset();
    this.localCustomerCod = null;
   
    this.resourceUnitCod = null;
    
    this.designedServiceCod = null;
    // HotFix, Reset resets the provider and theres no way to set it other than top right corner.
    // this.providerCod = providerSelect.cod;

    this.filterTable();
  }

  ngOnDestroy(): void {
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.chargesScartoService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.chargesScartoService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    const filter: ScartiConsuntivoChargesModel = new ScartiConsuntivoChargesModel();
    this.getNameSubscribe = this.chargesScartoService.getNameGenerateXlsx(this.offset, filter)
      .subscribe(
        resultPage => {
              const currentDate = new Date();
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(new Blob([resultPage], { type: this.EXCEL_TYPE }),
                  'Charges Waste' + ' - ' + currentDate + '.xlsx');
              } else {
                FileSaver.saveAs(new Blob([resultPage], { type: this.EXCEL_TYPE }), 'Charges Waste' + ' - ' + currentDate + '.xlsx');
              }
              toastr.success('XLS downloaded with success', 'Success');

              this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadXlsx() {
    this.getAllFilters();
    const reportFilter = this.filter as ScartiConsuntivoChargesReportModel;
    if (this.reportSection) {
      reportFilter.numAnnoMeseTo = this.numAnnoFilterComponent.optionSelected;
      reportFilter.numAnnoMeseFrom = this.numAnnoFilterComponent.optionSelectedFrom;
    } else {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMese;
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMese;
    }
    if (!reportFilter.numAnnoMeseFrom && reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseFrom = reportFilter.numAnnoMeseTo;
    } else if (reportFilter.numAnnoMeseFrom && !reportFilter.numAnnoMeseTo) {
      reportFilter.numAnnoMeseTo = reportFilter.numAnnoMeseFrom;
    } else {
      console.error('year month filter is missing');
    }

    this.loaderService.display(true);
    this.generateScartiVolumiXlsx(reportFilter);
  }

  generateScartiVolumiXlsx(reportFilter) {
    let fileName = 'Monthly Charges Error';
    if (this.filter.isRecovery) {
      fileName = 'Charges Balance Error';
    }
    this.getNameSubscribe = this.chargesScartoService.getNameGenerateXlsx(this.offset, reportFilter)
      .subscribe(
        resultPage => {
          const currentDate = this.getDate();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(
              new Blob([resultPage],
                {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob([resultPage], {type: this.EXCEL_TYPE}),
              fileName + ' - ' + currentDate + ' From ' + reportFilter.numAnnoMeseFrom + ' To ' + reportFilter.numAnnoMeseTo + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');
          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  getDate() {
    const date = new Date();
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0');
  }

  openDialogDownloadXlsx() {
    if (this.reportSection) {
      this.filterTable();
    }
    this.getAllFilters();

    const list: GenericArray[] = [
        {id: 'filter', value: this.filter},
        {id: 'offset', value: this.offset},
        {id: 'numAnnoMeseData', value: this.numAnnoMeseData},
        {id: 'serviceReportPage', value: this.SERVICE_REPORT_DOWNLOAD.CONSUMPTIVE_CHARGES_WASTE}
      ],
      dialogRef = this.dialog.open(DialogYearMonthComponent, {
        data: {list}
      });
    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });

  }

  getAllFilters() {
    if (!this.reportSection) {
      this.filter.numAnnoMese = this.numAnnoFilterComponent.optionSelected;
    }    this.filter.localCustomerCod = this.localCustomerCod;
    this.filter.localCustomerCod = this.localCustomerCod ? this.localCustomerCod : '';
    if(!this.providerCod.includes('KYN')){
    this.filter.regionCod = this.regionCod ? this.regionCod : '';
    this.filter.contractCod = this.contractTypeCod ? this.contractTypeCod : '';
    }
    this.filter.resourcesUnitCod = this.resourceUnitCod ? this.resourceUnitCod : '';
    this.filter.designedServiceCod = this.designedServiceCod ? this.designedServiceCod : '';
    this.filter.providerCod = this.providerCod ? this.providerCod : '';
    this.loaderService.display(false);
  }

  interceptNumAnnoMeseChange(event) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptNumAnnoMeseFromChange($event: any) {
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptProviderChange(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptContractTypeChange(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptRegionChange(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptLocalCustomerChange(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptResourceUnitChange(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptSl1Change(value: string) {
    if (!this.reportSection) {
      if (value === '') {
        this.intermittentBool = false;
      } else {
        this.intermittentBool = true;
      }
      this.intermittentFilterButton(this.intermittentBool);
    }
  }
}
